import { combineReducers } from 'redux'
import userReducer from "./userReducer"
import authReducer from './authReducer'
import uiReducer from "./uiReducer"
import projectReducer from "./projectReducer"
import profileReducer from "./profileReducer"
import userAgencyReducer from "./userAgencyReducer"
import taskReducer from "./taskReducer"
import dashboardReducer from "./dashboardReducer"
import boardsReducer from './boardsReducer'
import tasksReducer from './tasksReducer'
import pipelineReducer from './pipelineReducer'
import opportunityReducer from './opportunityReducer'
import commentReducer from './commentReducer'
import leadStatusReducer from './leadStatusReducer'
import leadReducer from './leadReducer'
import historyReducer from './historyReducer'
import activityReducer from './activityReducer'
// Workflow/Automation removed - import workflowReducer from './workflowReducer'
// Funnel removed - import funnelReducer from './funnelReducer'
// Schedule removed - import scheduleReducer from "./scheduleReducer"
import workSpaceReducer from "./workSpaceCloningReducer"

const rootReducer = combineReducers({
    users: userReducer,
    auth: authReducer,
    UI: uiReducer,
    project: projectReducer,
    profile: profileReducer,
    userAgency: userAgencyReducer,
    tasks: taskReducer,
    dashboard: dashboardReducer,
    boards: boardsReducer,
    task: tasksReducer,
    pipeline: pipelineReducer,
    opportunity: opportunityReducer,
    comment: commentReducer,
    leadStatus: leadStatusReducer,
    lead: leadReducer,
    history: historyReducer,
    activity: activityReducer,
    workSpaceCloning:workSpaceReducer,
})

export default rootReducer;